export default {
  id: 150,
  title: 'Target #150 - Finger Heart',
  url: 'https://cssbattle.dev/play/150',
  colors: ['#4F77FF', '#1038BF'],
  solution:
    '<a a><a b><a c><style>[b],[c]{width:50;height:50;background:#1038bf}[a],[b],[c]{background:#1038bf}body{background:#4f77ff}a{position:fixed}[a]{top:0;left:0;width:150;height:150}[b]{top:150;left:100;border-radius:0 0 9in 9in}[c]{top:100;left:150;border-radius:0 9in 9in 0}</style>',
}
